export const ORDERS_GET_SAVED_FILTERVIEWS_REQUEST = 'ORDERS_GET_SAVED_FILTERVIEWS_REQUEST';
export const ORDERS_GET_SAVED_FILTERVIEWS_SUCCESS = 'ORDERS_GET_SAVED_FILTERVIEWS_SUCCESS';
export const ORDERS_SAVE_NEW_FILTERVIEW_REQUEST = 'ORDERS_SAVE_NEW_FILTERVIEW_REQUEST';
export const ORDERS_SAVE_NEW_FILTERVIEW_SUCCESS = 'ORDERS_SAVE_NEW_FILTERVIEW_SUCCESS';
export const ORDERS_SAVE_EXISTING_FILTERVIEW_REQUEST = 'ORDERS_SAVE_EXISTING_FILTERVIEW_REQUEST';
export const ORDERS_SAVE_EXISTING_FILTERVIEW_SUCCESS = 'ORDERS_SAVE_EXISTING_FILTERVIEW_SUCCESS';
export const ORDERS_DELETE_FILTERVIEW_REQUEST = 'ORDERS_DELETE_FILTERVIEW_REQUEST';
export const ORDERS_DELETE_FILTERVIEW_SUCCESS = 'ORDERS_DELETE_FILTERVIEW_SUCCESS';

export const ORDERS_SWITCH_FILTERVIEW = 'ORDERS_SWITCH_FILTERVIEW';
export const ORDERS_AUTOSWITCH_FILTERVIEW_DEFAULT = 'ORDERS_AUTOSWITCH_FILTERVIEW_DEFAULT';
export const ORDERS_AUTOSWITCH_FILTERVIEW_CUSTOM = 'ORDERS_AUTOSWITCH_FILTERVIEW_CUSTOM';

export const ORDERS_CHANGE_CUSTOM_FILTERVIEW_PROP = 'ORDERS_CHANGE_CUSTOM_FILTERVIEW_PROP';
export const ORDERS_CHANGE_DEFAULT_FILTERVIEW_PROP = 'ORDERS_CHANGE_DEFAULT_FILTERVIEW_PROP';
export const ORDERS_CHANGE_FILTERVIEW_PROP = 'ORDERS_CHANGE_FILTERVIEW_PROP';

export const LAUNCH_ORDERS_SAVE_VIEW_MODAL = 'LAUNCH_ORDERS_SAVE_VIEW_MODAL';
export const LAUNCH_ORDERS_EDIT_VIEW_MODAL = 'LAUNCH_ORDERS_EDIT_VIEW_MODAL';
export const LAUNCH_ORDERS_DELETE_VIEW_MODAL = 'LAUNCH_ORDERS_DELETE_VIEW_MODAL';

export const changeCustomFilterViewProp = (propName, propValue) => ({
  type: ORDERS_CHANGE_CUSTOM_FILTERVIEW_PROP,
  propName,
  propValue,
});

export const changeFilterViewProp = (filterViewId, propName, propValue) => ({
  type: ORDERS_CHANGE_FILTERVIEW_PROP,
  filterViewId,
  propName,
  propValue,
});

export const autoSwitchFilterViewToCustom = (appliedFilters, filterView) => ({
  type: ORDERS_AUTOSWITCH_FILTERVIEW_CUSTOM,
  appliedFilters,
  filterView,
});

export const autoSwitchFilterViewToDefault = () => ({
  type: ORDERS_AUTOSWITCH_FILTERVIEW_DEFAULT,
});

export const switchActiveFilterView = (filterViewId) => ({
  type: ORDERS_SWITCH_FILTERVIEW,
  filterViewId,
});

export const getSavedFilterViewsRequest = () => ({
  type: ORDERS_GET_SAVED_FILTERVIEWS_REQUEST,
});

export const getSavedFilterViewsSuccess = (savedFilterViews) => ({
  type: ORDERS_GET_SAVED_FILTERVIEWS_SUCCESS,
  savedFilterViews,
});

export const saveNewFilterViewRequest = (filterView) => ({
  type: ORDERS_SAVE_NEW_FILTERVIEW_REQUEST,
  filterView,
});

export const saveNewFilterViewSuccess = (filterView) => ({
  type: ORDERS_SAVE_NEW_FILTERVIEW_SUCCESS,
  filterView,
});

export const saveExistingFilterViewRequest = (filterView) => ({
  type: ORDERS_SAVE_EXISTING_FILTERVIEW_REQUEST,
  filterView,
});

export const saveExistingFilterViewSuccess = (filterView) => ({
  type: ORDERS_SAVE_EXISTING_FILTERVIEW_SUCCESS,
  filterView,
});

export const deleteFilterViewRequest = (filterView) => ({
  type: ORDERS_DELETE_FILTERVIEW_REQUEST,
  filterView,
});

export const deleteFilterViewSuccess = (filterView) => ({
  type: ORDERS_DELETE_FILTERVIEW_SUCCESS,
  filterView,
});

export const launchSaveViewModal = () => ({
  type: LAUNCH_ORDERS_SAVE_VIEW_MODAL,
});

export const launchEditViewModal = () => ({
  type: LAUNCH_ORDERS_EDIT_VIEW_MODAL,
});

export const launchDeleteViewModal = () => ({
  type: LAUNCH_ORDERS_DELETE_VIEW_MODAL,
});

export const APPLY_FILTER_SET = 'APPLY_FILTER_SET';
export const applyFilterSet = (appliedFilters, metadata) => ({
  type: APPLY_FILTER_SET,
  appliedFilters,
  metadata,
});
